import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading-a",
  "use": "icon-loading-a-usage",
  "viewBox": "0 0 44 16",
  "content": "<symbol viewBox=\"0 0 44 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-loading-a\">\n<circle cx=\"4\" cy=\"4\" r=\"4\" fill=\"#2E4EF5\" />\n<circle cx=\"16\" cy=\"12\" r=\"4\" fill=\"#306FF5\" />\n<circle cx=\"28\" cy=\"12\" r=\"4\" fill=\"#59C239\" />\n<circle cx=\"40\" cy=\"12\" r=\"4\" fill=\"#68E053\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol